/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/delete': {
    width: 37,
    height: 20,
    viewBox: '0 0 37 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.025 1.207A3 3 0 019.43 0h23.78a3 3 0 013 3v14a3 3 0 01-3 3H9.369a3 3 0 01-2.344-1.127l-5.367-6.715a3 3 0 01-.062-3.666l5.43-7.285z" _fill="#fff"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M20.374 11.93l-3.818 3.818L15 14.192l3.818-3.818L15 6.556 16.556 5l3.818 3.818L24.192 5l1.556 1.556-3.818 3.818 3.818 3.818-1.556 1.556-3.818-3.818z" _fill="#373A36"/>'
  }
})
